var _style, _linearGradient, _circle, _circle2, _circle3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactionAngry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1500",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:url(#SVGID_1_)}.st1{fill:#262c38}.st2{fill:none;stroke:#262c38;stroke-width:60;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 750,
    y1: 1501.519,
    x2: 750,
    y2: 4.759,
    gradientTransform: "matrix(1 0 0 -1 0 1499.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#f05766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f3766a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#ffda6b"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 750,
    cy: 750,
    r: 750
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 416.7,
    cy: 947,
    r: 73.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1082.7,
    cy: 947,
    r: 73.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.9 805.1s120.5 93.7 423.4 93.7M1291.9 805.1s-120.5 93.7-423.4 93.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M987.6 1211.4c0 41.7-106.7 43.3-238.4 43.3s-238.4-1.7-238.4-43.3c0-36.8 109.9-54.6 241.5-54.6s235.3 17.7 235.3 54.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionAngry);
export default __webpack_public_path__ + "static/media/reaction_angry.c553b30500a9f3f52c1235ffca93531f.svg";
export { ForwardRef as ReactComponent };